// extracted by mini-css-extract-plugin
export default {"sec1":"Index_sec1__TUMQl","sec2":"Index_sec2__yQ11E","sec3":"Index_sec3__h79Fy","sec4":"Index_sec4__iR1Tj","gallery":"Index_gallery__5RMGP"};